<template>
    <div class="infor fl">
        <all-header
            :label="lable"
            :ischage="ischage"
            :sublabel="sublabel"
            :subtitle="subtitle"
            @getvalue="getvalue"></all-header>
        <div v-if="step == 0" class="block-list">
            <div
                v-for="(item, index) in awardList"
                :key="index"
                class="block-list-item">
                <div class="block-list-item-r-t">
                    国家级
                </div>
                <div class="block-list-item-box">
                    <div class="block-list-item-box-t">
                        {{ item.title }}
                    </div>
                    <div class="block-list-item-box-dtae">
                        {{ item.year }}
                    </div>
                </div>
                <div
                    class="block-list-item-box-b"
                    :class="item.status == 0 ? 'block-list-item-box-b-d' : ''"
                    @click="onApplyTap(item)">
                    <!-- {{ item.user_status==0?'去申请':item.user_status==1?'待审核':item.user_status==2?'已申报':'审核未通过' }} -->
                    去查看
                </div>
            </div>
        </div>
        <div v-if="step == 1">
                <el-select v-model="award_batch_id"
                       placeholder="请选择批次"
                       class="award_batch"
                       @change="serch">
                <el-option v-for="(bitem,bindex) in award_batches" :label="bitem['year']" :value="bitem['id']"></el-option>
            </el-select>
            <div class="right_serch">
                <input id="" v-model="keyword" type="text" name="" placeholder="输入编号或企业名称搜索..." @keyup.enter="serch">
                <img src="../assets/serch.png" alt="" @click="serch">
            </div>
            <el-tabs
                v-model="activeName"
                style="margin-top: 16px"
                tab-position="top"
                @tab-click="handleClick">
                <el-tab-pane label="全部" name="first">
                    <el-form ref="ruleForm">
                        <el-table
                            v-loading="loading"
                            :data="formlist"
                            :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                            style="width: 100%; margin-top: 30px">
                            <el-table-column
                                prop="id"
                                label="材料编号"
                                min-width="90"></el-table-column>
                            <el-table-column show-overflow-tooltip
                                             prop="user.name"
                                             label="企业名称"
                                             min-width="140"></el-table-column>
                            <el-table-column
                                prop="created_at"
                                label="申报时间"
                                min-width="60"></el-table-column>
                            <el-table-column min-width="70" label="查看材料">
                                <template slot-scope="scope">
                                    <el-button
                                        size="small"
                                        style="color: #194abe"
                                        @click="getapply(scope.row)">
                                        查看材料
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="isGroupAward" prop="award_expert_score.score" min-width="70" label="得分">
                            </el-table-column>
                            <el-table-column v-if="isGroupAward" min-width="70" label="点评详情">
                                <template slot-scope="scope">
                                    <el-button
                                        size="small"
                                        style="color: #194abe"
                                        @click="giveAMark(scope.row)">
                                        去查看
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="!isGroupAward" min-width="60" label="审核结果">
                                <template slot-scope="scope">
                                    <el-button
                                        round
                                        size="small"
                                        style="color: #fff"
                                        :type="
                                            scope.row.award_log_expert_info.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                        :icon="
                                            scope.row.award_log_expert_info.status == 1
                                                ? 'el-icon-check'
                                                : 'el-icon-close'
                                        ">
                                        {{
                                            scope.row.award_log_expert_info.status == 1
                                                ? "通过"
                                                : "否决"
                                        }}
                                    </el-button>
                                </template>
                            </el-table-column>

                            <el-table-column v-if="!isGroupAward" min-width="100" label="查看">
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="scope.row.award_log_expert_info.status == 0"
                                        size="mini"
                                        @click="handleEdit(scope.$index, scope.row)">
                                        评审意见
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane v-if="!isGroupAward" label="未通过" name="second">
                    <el-form ref="ruleForm">
                        <el-table
                            :data="formlist"
                            :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                            style="width: 100%; margin-top: 30px">
                            <el-table-column
                                prop="id"
                                label="材料编号"
                                min-width="90"></el-table-column>
                            <el-table-column show-overflow-tooltip
                                             prop="user.name"
                                             label="企业名称"
                                             min-width="140"></el-table-column>
                            <el-table-column
                                prop="created_at"
                                label="申报时间"
                                min-width="60"></el-table-column>
                            <el-table-column min-width="70" label="查看材料">
                                <template slot-scope="scope">
                                    <el-button
                                        size="small"
                                        style="color: #194abe"
                                        @click="getapply(scope.row)">
                                        查看材料
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="60" label="审核结果">
                                <template slot-scope="scope">
                                    <el-button
                                        round
                                        size="small"
                                        style="color: #fff"
                                        :type="
                                            scope.row.award_log_expert_info.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                        :icon="
                                            scope.row.award_log_expert_info.status == 1
                                                ? 'el-icon-check'
                                                : 'el-icon-close'
                                        ">
                                        {{
                                            scope.row.award_log_expert_info.status == 1
                                                ? "通过"
                                                : "否决"
                                        }}
                                    </el-button>
                                </template>
                            </el-table-column>

                            <el-table-column min-width="100" label="查看">
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="scope.row.award_log_expert_info.status == 0"
                                        size="mini"
                                        @click="handleEdit(scope.$index, scope.row)">
                                        评审意见
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane v-if="!isGroupAward" label="已通过" name="third">
                    <el-form ref="ruleForm">
                        <el-table
                            :data="formlist"
                            :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                            style="width: 100%; margin-top: 30px">
                            <el-table-column
                                prop="id"
                                label="材料编号"
                                min-width="90"></el-table-column>
                            <el-table-column show-overflow-tooltip
                                             prop="user.name"
                                             label="企业名称"
                                             min-width="140"></el-table-column>
                            <el-table-column
                                prop="created_at"
                                label="申报时间"
                                min-width="60"></el-table-column>
                            <el-table-column min-width="70" label="查看材料">
                                <template slot-scope="scope">
                                    <el-button
                                        size="small"
                                        style="color: #194abe"
                                        @click="getapply(scope.row)">
                                        查看材料
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="60" label="审核结果">
                                <template slot-scope="scope">
                                    <el-button
                                        round
                                        size="small"
                                        style="color: #fff"
                                        :type="
                                            scope.row.award_log_expert_info.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                        :icon="
                                            scope.row.award_log_expert_info.status == 1
                                                ? 'el-icon-check'
                                                : 'el-icon-close'
                                        ">
                                        {{
                                            scope.row.award_log_expert_info.status == 1
                                                ? "通过"
                                                : "否决"
                                        }}
                                    </el-button>
                                </template>
                            </el-table-column>

                            <el-table-column min-width="100" label="查看">
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="scope.row.award_log_expert_info.status == 0"
                                        size="mini"
                                        @click="handleEdit(scope.$index, scope.row)">
                                        评审意见
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </el-tab-pane>
            </el-tabs>

            <el-dialog title="填写不通过原因" :visible.sync="dialogVisible" width="774px" :before-close="handleClose">
                <div class="yellow-box">
                    <span>{{ user.legal_representative_id }}</span>
                    <span>{{ user.name }}</span>
                    <span>申请提交于{{ user.created_at }}</span>
                </div>
                <p class="Failcontent">{{ content }}</p>
            </el-dialog>
            <pagetion :total="total" class="pos-page" @getpageValue="getpageValue"></pagetion>
        </div>

        <div v-if="step == 'giveAMark'">
            <group-score-form
                :type="activeAward.content.project_type"
                mode="view"
                :model="activeAward"
                @viewFile="() => getapply(activeAward)"
                @success="handleGiveAMarkSuccess">
            </group-score-form>
        </div>
    </div>
</template>

<script>
import AllHeader from '@/components/Modal/AllHeader'
import Pagetion from '@/components/Modal/Pagetion'
import GroupScoreForm from './applyAward/groupScoreForm.vue'
import {
    expertaward,
    expertverifyLogs,
    AwardList,
    AwardInfo, //申报记录详情
    AwardLog, //申报奖项
    Address //填写地址
} from '../utils/api.js'
export default {
    components: {
        AllHeader,
        Pagetion,
        GroupScoreForm
    },
    data() {
        return {
            content:'',//不通过原因
            dialogVisible:false,//不通过弹框
            user:{},
            isIndex:0,
            activeName: 'first',
            step: 0,
            ischage: false,
            lable: '',
            pageSize: 8,
            total: 0,
            awardList: [],
            sublabel: '返回奖项列表',
            subtitle: '', //副标题
            formlist: [],
            prizeid: '',//奖项id
            keyword:'',//搜索
            activeAward: {},
            activeRow: {},
            loading: false,
            award_batches:[],
            award_batch_id:0
        }
    },
    computed: {
        isGroupAward() {
            return this.subtitle === '工程建设质量管理小组竞赛活动'
        }
    },
    mounted() {
        this.lable = this.$route.query.name
        this.token = 'Bearer ' + localStorage.getItem('TOKEN')
        this.initList(1)
    },
    methods: {
        async initList(page) {
            const data = {
                page_size: this.pageSize,
                page: page,
                type: 2
            }
            let res = await expertaward(data)
            this.awardList = res.data || []
            console.log(789, this.awardList)
            this.total = res.total
        },
        async onApplyTap(row) {
            if(row.id == 21){
                this.$router.push('/gfprize/Awardbatch?award_id='+row.id)
                return;
            }
            const { id, status, title, content ,award_batches} = row
            this.prizeid = id
            this.getexpertverifyLogs(id,{award_batch_id:this.award_batch_id})
            this.activeRow = row
            this.ischage = true
            this.step = 1
            this.subtitle = title;
            console.log('row.award_batches',award_batches)
            this.award_batches = award_batches ? award_batches : [];
            let last_award_batch_id = 0;
            for(var i = 0; i < this.award_batches.length; i ++){
                this.award_batches[i]['year'] = this.award_batches[i]['year']+'-'+this.award_batches[i]['batch']
                last_award_batch_id = this.award_batches[i]['id'];
            }
            this.award_batch_id = last_award_batch_id;//this.award_batches[0] != undefined ? this.award_batches[0]['id'] : '';
        },
        getvalue() {
            this.step = 0
            this.ischage = false
            this.lable = this.$route.query.name
            this.subtitle = ''
        },
        //搜索
        serch(){
            let data
            this.keyword = this.keyword.toString()
            if (this.isIndex != 0) {
                data = {
                    status: this.isIndex - 1,
                    keyword:this.keyword,
                    award_batch_id:this.award_batch_id
                }
            }else{
                data = {
                    keyword:this.keyword,
                    award_batch_id:this.award_batch_id
                }
            }
            this.getexpertverifyLogs(this.prizeid,data)
        },
        getexpertverifyLogs(id,data){
            this.loading = true
            
            expertverifyLogs(id, data).then((res) => {
                this.formlist = res
                this.formlist.forEach((e) => {
                    e.created_at = e.created_at.slice(0, 10)
                })
            }).finally(() => {
                this.loading = false
            })
        },
        getapply(obj) {
            if (obj.content) {
                if (this.isGroupAward) {
                    const resolve = this.$router.resolve(`/word_1?title=${this.subtitle}&id=${obj.id}&states=审核&no_back=1&nav_title=预览项目评审材料`)
                    window.open(resolve.href, '_blank')
                } else {
                    const resolve = this.$router.resolve(`/word_1?title=${this.subtitle}&id=${obj.id}&states=审核&no_back=1`)
                    window.open(resolve.href, '_blank')
                    //this.$router.push(`/word_1?title=${this.subtitle}&id=${obj.id}&states=审核`)
                }
            }else if (obj.file_urls) {
                location.href = obj.file_urls[0]
            }
        },
        // 去评分
        giveAMark(row) {
            this.step = 'giveAMark'
            this.activeAward = row
        },
        handleEdit(a,b) {
            console.log(a,b)
            this.dialogVisible = true
            this.user = b.user
            this.id = b.id
            this.content = b.award_log_expert_info.content
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done()
                })
                .catch((_) => {})
        },
        handleDelete() {},
        handleClick(e) {
            let data
            this.isIndex = e.index
            if (e.index != 0) {
                data = {
                    status: e.index - 1,
                    award_batch_id:this.award_batch_id
                }
            }
            this.getexpertverifyLogs(this.prizeid, data)
        },
        getpageValue(){

        },
        handleGiveAMarkSuccess() {
            this.step = '1'
            this.onApplyTap(this.activeRow)
        }
    }
}
</script>

<style>
.el-tabs__nav-scroll {
  justify-content: flex-start !important;
}
.el-tabs__header {
  width: 40%;
}
</style>
<style lang="less" scoped>
/deep/.block-title {
  border-left: 3px solid #194abe !important;
}
.yellow-box{
    height: 40px;
    background: #FEF8EF;
    opacity: 1;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    span{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 24px;
        &:nth-child(1){
            color: #194ABE;
        }
        &:nth-child(2){
            color: #0C0D0F;
        }
        &:nth-child(3){
            color: #7C828A;
            font-size: 14px;
        }
    }
}
.reason{
    margin-top: 20px;
    width: 100%;
    height: 162px;
    background: #FFFFFF;
    border: 1px solid #BDC3CB;
    opacity: 1;
    border-radius: 4px;
    outline: none;
    padding: 10px;
    box-sizing: border-box;
}
.Failcontent {
  display: block;
  width: 100%;
  text-align: start;
  // height: 92px;
  background: #ffffff;
  opacity: 1;
  border-radius: 4px;
  padding: 20px 10px;
  box-sizing: border-box;
}
.right_serch {
  position: absolute;
  right: 30px;
  top: 90px;
  width: 234px;
  height: 33px;
  background: #ffffff;
  border: 1px solid #c8cdd5;
  opacity: 1;
  border-radius: 6px;
  padding-left: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: start;
  input {
    width: 164px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #c8cdd5;
    outline: none;
    border: none;
  }
  img {
    margin-left: 30px;
  }
}
.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
    position: relative;
    &-r-t {
      position: absolute;
      top: 0;
      right: 0;
      width: 73px;
      height: 27px;
      background: #f5f9fb;
      opacity: 1;
      border-radius: 0px 0px 0px 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #c6c9ce;
      padding-left: 10px;
      box-sizing: border-box;
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
.right_serch {
    z-index: 999;
}
.award_batch {
    position: absolute;
    right: 270px;
    top: 84px;
    height: 33px;
    line-height: 33px;
    z-index: 999;
}
.award_batch input {
    height: 33px !important;
    line-height: 33px  !important;
}
</style>
